import React, { useEffect, useRef, useState } from "react";
import Index from "../../../Index";
import Pagination from "../../../../components/common/Pagination";
import PagesIndex from "../../../PagesIndex";
import { getFamilyWiseReport } from "../../../../redux/features/AddService";
import PageLoading from "../../../../components/common/pageLoading/PageLoading";
import FileExcel from "../../../../components/common/excelSheet/FileExcel";
import { Autocomplete } from "@mui/material";
import RowPerPageDropdown from "../../../../components/common/paginationRowPerpage/RowPerPageDropdown";
import dataService from "../../../../config/DataService";
import { Api } from "../../../../config/Api";
import { useReactToPrint } from "react-to-print";
import PrintReport from "../../../../components/common/printReport/PrintReport";
import { useSelector } from "react-redux";

export default function FamilyReportData() {
  const { getFamilyWiseReportList } = PagesIndex.useSelector(
    (state) => state?.admin
  );
  const fileName = "Family wise report CSV";
  const [excel, setExcel] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [rowPerPage, setRowPerPage] = useState("25");
  const dispatch = PagesIndex.useDispatch();
  const [filterSubSahayName, setFilterSubSahayName] = useState("");
  const [filter, setFilter] = useState("");
  const [filterApplicantName, setFilterApplicantName] = useState("");
  const [searchedData, setSearchedData] = useState([]);
  const [filterReportData, setFilterReportData] = useState([]);
  const [sahaySubTypeList, setSahaySubTypeList] = useState([]);
  const [filterYear, setFilterYear] = useState("");

  // Print Reports
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    dispatch(getFamilyWiseReport()).then((res) => {
      if (res?.payload?.status == 200) {
        setLoader(false);
      }
      setLoader(false);
    });
  }, [filter, filterSubSahayName, filterApplicantName]);

  //Filter Data
  useEffect(() => {
    if (filter || filterSubSahayName || filterApplicantName || filterYear) {
      const filterData = getFamilyWiseReportList?.data?.filter((ele) => {

        if (filter && filterSubSahayName && filterApplicantName && filterYear) {
          return (
            ele?.MohollaName === filter &&
            ele?.SubSahayName === filterSubSahayName &&
            ele?.ApplicantName === filterApplicantName &&
            ele?.Year === filterYear
          );
        }

        if (filterYear && filterSubSahayName) {
          return (
            ele?.Year === filterYear &&
            ele?.SubSahayName === filterSubSahayName
          );
        }

        if (filterYear && filterApplicantName) {
          return (
            ele?.Year === filterYear &&
            ele?.ApplicantName === filterApplicantName
          );
        }

        if (filterYear && filter) {
          return (
            ele?.Year === filterYear &&
            ele?.MohollaName === filter
          );
        }

        if (filterYear) {
          return ele?.Year === filterYear;
        }

        // existing conditions
        return (
          ele?.MohollaName === filter ||
          ele?.SubSahayName === filterSubSahayName ||
          ele?.ApplicantName === filterApplicantName
        );
      });

      setFilterReportData(filterData);
    } else {
      setFilterReportData([]);
    }
  }, [filter, filterSubSahayName, filterApplicantName, filterYear]);
  // useEffect(() => {
  //   if (filter || filterSubSahayName || filterApplicantName) {
  //     const filterData = getFamilyWiseReportList?.data?.filter((ele) => {
  //       if (filter && filterSubSahayName && filterApplicantName) {
  //         return (
  //           ele?.MohollaName == filter &&
  //           ele?.SubSahayName == filterSubSahayName &&
  //           ele?.ApplicantName == filterApplicantName
  //         );
  //       } else if (filter && filterApplicantName) {
  //         return (
  //           ele?.MohollaName == filter &&
  //           ele?.ApplicantName == filterApplicantName
  //         );
  //       } else if (filter && filterSubSahayName) {
  //         return (
  //           ele?.MohollaName == filter &&
  //           ele?.SubSahayName == filterSubSahayName
  //         );
  //       } else if (filterApplicantName && filterSubSahayName) {
  //         return (
  //           ele?.ApplicantName == filterApplicantName &&
  //           ele?.SubSahayName == filterSubSahayName
  //         );
  //       } else if (filter || filterSubSahayName || filterApplicantName) {
  //         return (
  //           ele?.MohollaName == filter ||
  //           ele?.SubSahayName == filterSubSahayName ||
  //           ele?.ApplicantName == filterApplicantName
  //         );
  //       } else {
  //         return [];
  //       }
  //     });
  //     setFilterReportData(filterData);
  //   } else {
  //     setFilterReportData([]);
  //   }
  // }, [filter, filterSubSahayName, filterApplicantName]);

  // Copy original data to searched data
  useEffect(() => {
    setSearchedData(filterReportData);
  }, [filterReportData]);

  // Search on table
  const requestSearch = (searched) => {
    if (!searched) return setSearchedData(filterReportData);
    setSearchedData(
      filterReportData?.filter(
        (item) =>
          item?.ApplicantName?.toString()
            ?.toLowerCase()
            .includes(searched?.toLowerCase()) ||
          item?.Area?.toString()
            ?.toLowerCase()
            .includes(searched?.toLowerCase())
      )
    );
  };
  //get Sub sahay list
  const getSahaySubTypeData = async () => {
    try {
      const res = await dataService.get(Api.GET_ALL_SUB_SAHAY_LIST);
      if (res?.data?.status) {
        setSahaySubTypeList(res?.data?.Data);
      } else {
        setSahaySubTypeList([]);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getSahaySubTypeData();
    if (filterReportData?.length > 0) {
      const customHeadings = filterReportData?.map((item) => ({
        Fid: item?.FID,
        "Applicant name": item?.ApplicantName,
        Area: item?.Area,
        "Moholla Name": item?.MohollaName,
        "Sub Sahay Name": item?.SubSahayName,
        " Aprrove Amount": item?.ApproveAmount,
        " Year": item?.Year,
      }));

      setExcel(customHeadings);
    }
  }, [filterReportData]);


  const { rollPermissionData } = useSelector((state) => state.admin);

  const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase();

  const navigate = PagesIndex.useNavigate();
  const rollPermissionNameData =
  rollPermissionData?.findData?.parentRoleName?.toLowerCase();

  if (
    rollPermissionData?.permissionArray?.includes("Family Wise Report_view")|| rollPermissionNameData === "admin"
  ) {
  } else {
    navigate(`/${rollData}/sahay-application`);
  }

  const sortedYearData = React.useMemo(() => {
  if (!getFamilyWiseReportList?.data) return [];


  return [...getFamilyWiseReportList.data].sort((a, b) => {
  const startYearA = parseInt(a?.Year?.split("-")[0]);
  const startYearB = parseInt(b?.Year?.split("-")[0]);


  return startYearB - startYearA; // DESC
  });
  }, [getFamilyWiseReportList?.data]);

  return (
    <>
      {loader ? (
        <PageLoading />
      ) : (
        <>
          <Index.Box className="page-content-box">
            <Index.Box className="barge-common-box">
              <Index.Box className="title-header">
                <Index.Box className="title-header-flex res-title-header-flex">
                  <Index.Box className="title-main">
                    <Index.Typography
                      variant="p"
                      component="p"
                      className="page-title"
                    >
                      Family Wise Report
                    </Index.Typography>
                  </Index.Box>
                </Index.Box>
              </Index.Box>

              <Index.Box className="grid-row  sahay-multiple-main">
                <Index.Box sx={{ width: 1 }} className="grid-main">
                  <Index.Box
                    display="grid"
                    className="app-report-row"
                    gridTemplateColumns="repeat(12, 1fr)"
                    gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                  >
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="sahay-multiple-input-main">
                        <PagesIndex.Search
                          className="search sahay-multiple-search"
                          onChange={(e) => requestSearch(e.target.value)}
                        >
                          <PagesIndex.StyledInputBase placeholder="Search" />
                        </PagesIndex.Search>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="sahay-multiple-input-main">
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          className="multiple-autocomplet-control"
                          options={getFamilyWiseReportList?.data || []}
                          getOptionLabel={(option) => option?.MohollaName}
                          onChange={(value, newvalue) => {
                            setFilter(newvalue?.MohollaName);
                          }}
                          filterOptions={(options, { inputValue }) => {
                            const inputLowerCase = inputValue?.toLowerCase();
                            const uniqueMohollaNames = new Set();
                            return options?.filter((option) => {
                              const mohollaName = option?.MohollaName?.toLowerCase();
                              // Check unique
                              if (uniqueMohollaNames?.has(mohollaName)) {
                                return false;
                              }
                              // Check search
                              if (mohollaName?.includes(inputLowerCase)) {
                                uniqueMohollaNames?.add(mohollaName);
                                return true;
                              }
                              return false;
                            });
                          }}
                          renderInput={(params) => (
                            <Index.TextField {...params} label="Moholla Name" />
                          )}

                        />
                      </Index.Box>
                    </Index.Box>
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="sahay-multiple-input-main">
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          className="multiple-autocomplet-control"
                          options={getFamilyWiseReportList?.data || []}
                          getOptionLabel={(option) => option?.ApplicantName}
                          onChange={(value, newvalue) => {
                            setFilterApplicantName(newvalue?.ApplicantName);
                          }}
                          filterOptions={(options, { inputValue }) => {
                            const inputLowerCase = inputValue?.toLowerCase();
                            const uniqueApplicantName = new Set();
                            return options?.filter((option) => {
                              const applicantName = option?.ApplicantName?.toLowerCase();
                              // Check unique
                              if (uniqueApplicantName?.has(applicantName)) {
                                return false;
                              }
                              // Check search
                              if (applicantName?.includes(inputLowerCase)) {
                                uniqueApplicantName?.add(applicantName);
                                return true;
                              }
                              return false;
                            });
                          }}
                          renderInput={(params) => (
                            <Index.TextField
                              {...params}
                              label="Applicant Name"
                            />
                          )}
                        />
                      </Index.Box>
                    </Index.Box>
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="sahay-multiple-input-main">
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          className="multiple-autocomplet-control"
                          options={sahaySubTypeList}
                          getOptionLabel={(option) => option?.SahayName}
                          onChange={(value, newvalue) => {
                            setFilterSubSahayName(newvalue?.SahayName);
                          }}
                          renderInput={(params) => (
                            <Index.TextField {...params} label="Sub Sahay" />
                          )}
                        />
                      </Index.Box>
                    </Index.Box>
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="sahay-multiple-input-main">
                        <Autocomplete
                          disablePortal
                          className="multiple-autocomplet-control"
                          options={sortedYearData}
                          // options={getFamilyWiseReportList?.data || []}
                          getOptionLabel={(option) => option?.Year || ""}
                          onChange={(e, newValue) => {
                            setFilterYear(newValue?.Year || "");
                          }}
                          filterOptions={(options, { inputValue }) => {
                            const inputLower = inputValue.toLowerCase();
                            const uniqueYears = new Set();

                            return options.filter((option) => {
                              const year = option?.Year?.toLowerCase();
                              if (!year) return false;

                              // unique check
                              if (uniqueYears.has(year)) return false;

                              // search check
                              if (year.includes(inputLower)) {
                                uniqueYears.add(year);
                                return true;
                              }
                              return false;
                            });
                          }}
                          renderInput={(params) => (
                            <Index.TextField {...params} label="Sahay Year" />
                          )}
                        />
                      </Index.Box>
                    </Index.Box>
                    {filterReportData?.length > 0 && (
                      <>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 3",
                            lg: "span 3",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="sahay-multiple-input-main">
                            <Index.Box
                              Box
                              className="res-auto-left common-button blue-button multiple-download-btn res-blue-button"
                            >
                              <FileExcel apiData={excel} fileName={fileName} />
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 4",
                            lg: "span 3",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="sahay-multiple-input-main">
                            <Index.Box
                              Box
                              className="res-auto-left common-button blue-button multiple-download-btn res-blue-button"
                            >
                              <Index.Button onClick={handlePrint}>
                                Print
                              </Index.Button>
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>
                      </>
                    )}
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <Index.Box className="table-list">
                <Index.TableContainer
                  component={Index.Paper}
                  className="table-container user-master-container"
                >
                  <Index.Table
                    aria-label="simple table"
                    className="table-design-main barge-table family-wise-report-table "
                  >
                    <Index.TableHead className="user-master-head">
                      <Index.TableRow className="user-master-tr">
                        <Index.TableCell className="user-master-th">
                          Fid
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Applicant Name
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Area
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Moholla Name
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Sub Sahay Name
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Aprrove Amount
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Year
                        </Index.TableCell>
                      </Index.TableRow>
                    </Index.TableHead>
                    <Index.TableBody className="user-master-tbody">
                      {pageData?.length &&
                      (filter || filterSubSahayName || filterApplicantName || filterYear) ? (
                        pageData?.map((data, index) => (
                          <Index.TableRow className="user-master-tr">
                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-role-name">
                                {data?.FID || "-"}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-details-name">
                                {data?.ApplicantName || "-"}
                              </Index.Box>
                            </Index.TableCell>

                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-email-name">
                                {data?.Area || "-"}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-number-name">
                                {data?.MohollaName || "-"}
                              </Index.Box>
                            </Index.TableCell>

                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-number-name">
                                {data?.SubSahayName || "-"}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-number-name">
                                {data?.ApproveAmount || "-"}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-number-name">
                                {data?.Year || "-"}
                              </Index.Box>
                            </Index.TableCell>
                          </Index.TableRow>
                        ))
                      ) : (
                        <PagesIndex.NoRecordFound colSpan={12} />
                      )}
                    </Index.TableBody>
                  </Index.Table>
                </Index.TableContainer>
              </Index.Box>
              <Index.Box className="pagination-design flex-end">
                <RowPerPageDropdown
                  rowPerPage={rowPerPage}
                  setRowPerPage={setRowPerPage}
                />
                <Index.Stack spacing={2}>
                  <Pagination
                    fetchData={searchedData}
                    setPageData={setPageData}
                    pageData={pageData}
                    rowPerPage={rowPerPage}
                  />
                </Index.Stack>
              </Index.Box>
            </Index.Box>
          </Index.Box>
          <Index.Box sx={{ display: "none" }}>
            <PrintReport
              componentRef={componentRef}
              tableData={excel}
              reportName={[{ type: "FamilyWiseReport" }]}
            />
          </Index.Box>
        </>
      )}
    </>
  );
}
